/**
 * Umschalter zwischen hellem und dunklem Thema.
 *
 * Eigene Datei, damit er sich prüfen lässt, ohne die ganze Anwendung samt
 * Anmeldung und Routen zu laden — der Fehler, den er hatte, war genau die
 * Sorte, die ein Test in zwei Zeilen fängt und ein Blick auf den Code nicht.
 */

import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { gegenteil, useTheme } from "@/theme";

export function ThemaSchalter() {
  // Drei Zustände wären ein Menü; zwei genügen. "system" schaltet beim ersten
  // Antippen auf das Gegenteil dessen, was gerade zu sehen ist.
  //
  // `istDunkel` kommt aus dem Kontext, nicht aus der Klasse am <html>-Element:
  // Die ist eine Ausgabe des Effekts und ändert sich, ohne dass React davon
  // erführe. Der Schalter blieb dadurch auf „dunkel“ stehen, und weil er dann
  // erneut „dunkel“ setzte, änderte sich auch kein Zustand mehr — das dunkle
  // Thema ließ sich nicht mehr abschalten.
  const { theme, istDunkel, setTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label={istDunkel ? "Helles Thema" : "Dunkles Thema"}
      onClick={() => setTheme(gegenteil(istDunkel))}
      title={theme === "system" ? "Folgt dem System" : undefined}
    >
      {istDunkel ? <Sun /> : <Moon />}
    </Button>
  );
}
